import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const RetailerStory = () => {
  const isRTL = i18next.dir() === "rtl";
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 1024);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return (
    <section className="py-8 md:py-16 bg-white" style={{ borderBottom: "2px gray-500" }}>
      <div className="mx-auto" style={{ maxWidth: "1180px", paddingLeft: "10px", paddingRight: "10px" }}>
        <div className="grid items-center gap-8 md:gap-[70px] lg:grid-cols-2">

          {/* LEFT: Video Embed */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              style={{
                borderRadius: "16px",
                overflow: "hidden",
                background: "#2b2b2b",
                aspectRatio: "16/9",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                minHeight: "200px",
                width: isMobile ? "80%" : "100%",
              }}
            >
              <iframe
                src="https://youtube.com/embed/-KiRZBlCaxg?si=HuqCRuRsf5svsPYz"
                title="Retailer Story"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: "16px",
                }}
              />
            </div>
          </div>

          {/* RIGHT: Text Content */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: isMobile ? "center" : "flex-start",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            {/* Label */}
            <p
              style={{
                fontSize: "13px",
                fontWeight: "700",
                letterSpacing: "0.1em",
                
                textTransform: "uppercase",
                color: "#1b4597",
                margin: 0,
              }}
            >
              Retailer Story
            </p>

            {/* Heading */}
            <h2
              style={{
                fontSize: "clamp(26px, 3.5vw, 42px)",
                fontWeight: "800",
                color: "#0f1941",
                lineHeight: "1.15",
                margin: 0,
              }}
              className="tracking-tight"
            >
              See how Egyptian retailers grow with Hisabak
            </h2>

            {/* Description */}
            <p
              style={{
                fontSize: "16px",
                color: "#6b7280",
                lineHeight: "1.65",
                margin: 0,
              }}
            >
              Hear it straight from a store owner — how they cut billing time, stopped stock-outs,
              and finally see their daily profit without lifting a calculator.
            </p>

            {/* Checkmarks */}
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                alignItems: isMobile ? "center" : "flex-start",
                width: "100%",
              }}
            >
              {[
                "2-minute real-store walkthrough",
                "Live POS, inventory & reports in action",
                "No scripts. No actors. Real numbers.",
              ].map((item) => (
                <li
                  key={item}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    justifyContent: isMobile ? "center" : "flex-start",
                  }}
                >
                  <span
                    style={{
                      width: "20px",
                      height: "20px",
                      minWidth: "20px",
                      borderRadius: "50%",
                      background: "#22c55e",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg width="11" height="8" viewBox="0 0 11 8" fill="none">
                      <path d="M1 4L4 7L10 1" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span style={{ fontSize: "15px", color: "#374151", fontWeight: "500" }}>{item}</span>
                </li>
              ))}
            </ul>

            {/* Divider */}
            <hr style={{ border: "none", borderTop: "1px solid #e5e7eb", margin: "4px 0", width: "100%" }} />

            {/* Featured Retailer */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "14px",
                justifyContent: isMobile ? "center" : "flex-start",
              }}
            >
              <div
                style={{
                  width: "46px",
                  height: "46px",
                  minWidth: "46px",
                  borderRadius: "50%",
                  background: "#1b4597",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontWeight: "700",
                  fontSize: "15px",
                  letterSpacing: "0.03em",
                }}
              >
                AM
              </div>
              <div>
                <p style={{ margin: 0, fontWeight: "700", fontSize: "15px", color: "#0f1941" }}>
                  Featured retailer
                </p>
                <p style={{ margin: 0, fontSize: "13px", color: "#6b7280" }}>
                  Cairo · Multi-branch grocery
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default RetailerStory;